// `accept` values for <FileUpload> — keep in sync with UPLOAD_LIMITS in shared.
// MP4/M4A as sound: the backend extracts the audio track.
export const SOUND_ACCEPT = "audio/*,.mp3,.wav,.ogg,.webm,.mp4,.m4a,.aac";
export const VIDEO_ACCEPT = "video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov";
export const MEDIA_ACCEPT = `image/*,${VIDEO_ACCEPT}`;
const VIDEO_EXT = /\.(webm|mp4|mov)$/i;
export function isVideoFile(name) {
    return VIDEO_EXT.test(name);
}
/** Matches uploaded/stored video URLs (MOV is stored as MP4 after upload). */
export function isVideoUrl(url) {
    return /\.(webm|mp4)$/i.test(url);
}
/**
 * Uploads a file for the channel. Throws with the server's message on failure
 * so <FileUpload> can show it — previously failed uploads were silently ignored.
 */
export async function uploadChannelFile(channelId, kind, file) {
    const formData = new FormData();
    formData.append("file", file);
    const token = localStorage.getItem("token");
    const res = await fetch(`/api/channels/${channelId}/uploads/${kind}`, {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: formData,
    });
    let data = null;
    try {
        data = await res.json();
    }
    catch {
        // non-JSON (e.g. 413 from the proxy)
    }
    if (!res.ok || !data?.success) {
        if (res.status === 413)
            throw new Error("Datei ist zu groß.");
        throw new Error(data?.error ?? `Upload fehlgeschlagen (HTTP ${res.status})`);
    }
    return data.data;
}
